var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { Input } from 'antd';
var TextArea = Input.TextArea;
var StyledTextArea = styled(TextArea)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var width = _a.width, margin = _a.margin, minheight = _a.minheight;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: 6px;\n    width: ", ";\n    margin: ", ";\n    min-height: ", ";\n  "], ["\n    border-radius: 6px;\n    width: ", ";\n    margin: ", ";\n    min-height: ", ";\n  "])), width || '100%', margin || 0, minheight || 'unset');
});
export default StyledTextArea;
var templateObject_1, templateObject_2;
